export default __webpack_public_path__ + "locales/ko-KR/RoomLogoCover.json?hash=320bbd55cc690c996616cd366b8c39e8";